export const UPDATE_COMUNICADO_CATEGORIAS = 'UDPATE_COMUNICADO_CATEGORIAS'
export const ADD_COMUNICADO_CATEGORIAS = 'ADD_COMUNICADO_CATEGORIAS'
export const SET_COMUNICADO_CATEGORIAS = 'SET_COMUNICADO_CATEGORIAS'
export const REMOVE_COMUNICADO_CATEGORIAS = 'REMOVE_COMUNICADO_CATEGORIAS'
export const SET_COMUNICADO_CATEGORIA = 'SET_COMUNICADO_CATEGORIA'
